import React from 'react';
import ReactSVG from 'react-svg';
import { CircularProgress, DialogContent } from '@material-ui/core';
import * as lib from '~/dependencies';
import { SelectedIcon, NoSelectedIcon } from '~/assets/svgIcons';
import { truncate } from '~/helpers';
import { BoxAccounts, ListAccounts, Dialog } from './styles';

export default function Accounts({
  accounts,
  changeAccount,
  acc,
  userInfo,
  loading,
}) {
  const verify = Object.values(accounts).findIndex(
    e => e.account_id === userInfo.account_id
  );
  // HOOKS
  const { t } = lib.useTranslation();

  return (
    <BoxAccounts>
      <h3>{t('screens.configuration.components.selectAccounts')}</h3>
      {/* {loading && <CircularProgress className="loading" />} */}
      <Dialog open={loading} aria-labelledby="draggable-dialog-title">
        <DialogContent>
          <CircularProgress className="loading" />
        </DialogContent>
      </Dialog>
      <ListAccounts>
        {verify === -1 && (
          <div
            className="row"
            onClick={() => changeAccount(userInfo.account_id)}
            role="presentation">
            <div>
              <span>{truncate(userInfo.account_name, 21)}</span>
              <span>{userInfo?.account_id?.replace('IE-', '')}</span>
            </div>
            <ReactSVG src={SelectedIcon} className="icon" />
          </div>
        )}
        {Object.values(accounts).map(e => (
          <div
            key={e.account_id}
            className="row"
            onClick={() => changeAccount(e.account_id)}
            role="presentation">
            <div>
              <span>{e.company_name}</span>
              <span>{e.account_id}</span>
            </div>
            {e.account_id === acc ? (
              <ReactSVG src={SelectedIcon} className="icon" />
            ) : (
              <ReactSVG src={NoSelectedIcon} className="icon" />
            )}
          </div>
        ))}
      </ListAccounts>
    </BoxAccounts>
  );
}

Accounts.defaultProps = {
  accounts: [],
  userInfo: [],
  acc: '',
  loading: false,
  changeAccount: () => {},
};

Accounts.propTypes = {
  accounts: lib.PropTypes.instanceOf(Object),
  userInfo: lib.PropTypes.instanceOf(Object),
  acc: lib.PropTypes.string,
  loading: lib.PropTypes.bool,
  changeAccount: lib.PropTypes.func,
};
